import { useMutation } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

type SendTestSmsPayload = {
  MarketingCampaignId: number;
  MarketingSMSId?: number;
  PhoneNumber: string;
};

export function useSendTestSmsMutation() {
  return useMutation({
    mutationFn: async (payload: SendTestSmsPayload) => {
      const res = postData({
        endpoint: 'api/sms-marketing/test-send-sms',
        payload,
      });
      return res;
    },
  });
}
